/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon20Solid = forwardRef('ArrowShapeTriangleADownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.368 6h9.263a1 1 0 0 1 .832 1.555l-4.631 6.947a1 1 0 0 1-1.665 0l-4.63-6.947A1 1 0 0 1 5.367 6Z" })));
});
